import { ChevronDownIcon, CheckIcon } from '@chakra-ui/icons';
import { Button, IconButton } from 'Atoms/Buttons/Buttons.tsx';
import { Menu, MenuSection } from 'Molecules/Menu/Menu.tsx';
import { Box, HStack, MenuButton } from '@chakra-ui/react';
import React, { useState } from 'react';
import { SortAscendingIcon, SortIcon } from 'Tokens/Icons/Function.tsx';
import { TaskListSortBy } from '../hooks/TaskList.hooks.ts';

interface TaskSortingMenuProps {
  sortBy: TaskListSortBy;
  setSortBy: (sort: TaskListSortBy) => void;
  sortDirection?: 'asc' | 'desc';
  setSortDirection?: (dir: 'asc' | 'desc') => void;
  isHomepage?: boolean;
}

const sortOptions = [
  { value: 'deadline', label: 'Deadline' },
  { value: 'status', label: 'Status' },
  { value: 'owner', label: 'Owner' },
  { value: 'standard', label: 'Standard' },
  { value: 'businessUnit', label: 'Business Unit' },
];

export const TaskSortingMenu: React.FC<TaskSortingMenuProps> = ({
  sortBy,
  setSortBy,
  sortDirection,
  setSortDirection,
  isHomepage,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const hasSortDirection = !!sortDirection && !!setSortDirection;

  const sections: MenuSection[] = [
    {
      title: 'Sort by',
      actions: sortOptions
        .filter((opt) =>
          isHomepage
            ? !['businessUnit','owner' ,'standard'].includes(opt.value)
            : true
        )
        .map((opt) => ({
          id: opt.value,
          render: () => (
            <HStack justify="space-between" width="100%">
              <Box
                color={sortBy === opt.value ? 'text.selected' : undefined}
                fontWeight={sortBy === opt.value ? 600 : 400}
              >
                {opt.label}
              </Box>
              {sortBy === opt.value && <CheckIcon color="text.selected" boxSize={3} />}
            </HStack>
          ),
          onClick: () => setSortBy(opt.value as any),
          closeOnClick: true,
        })),
    },
  ];

  return (
    <HStack spacing={0} align="center" justify="flex-start">
      <Menu
        customMenuButton={
          <MenuButton
            as={Button}
            variant="ghost"
            px="8px"
            size="sm"
            onClick={(e) => e.stopPropagation()}
            bgColor={menuOpen ? 'bg.pressed' : ''}
            rightIcon={<ChevronDownIcon />}
            _hover={{ bgColor: 'bg.hover' }}
          >
            {sortOptions.find((opt) => opt.value === sortBy)?.label}
          </MenuButton>
        }
        isOpen={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => setMenuOpen(false)}
        sections={sections}
        size="md"
      />
      {hasSortDirection && (
        <IconButton
          aria-label={sortDirection === 'asc' ? 'Ascending' : 'Descending'}
          icon={sortDirection === 'asc' ? <SortIcon /> : <SortAscendingIcon />}
          variant="ghost"
          size="sm"
          onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}
        />
      )}
    </HStack>
  );
};
